// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-left-column';

export const Component = () => (
  <path d='M20.115 0H4.406C3.21 0 2.156.431 1.293 1.293A4.267 4.267 0 0 0 0 4.406v15.709c0 1.198.431 2.25 1.293 3.113a4.267 4.267 0 0 0 3.113 1.293h15.709c1.198 0 2.25-.431 3.113-1.293a4.267 4.267 0 0 0 1.293-3.113V4.406c0-1.197-.431-2.25-1.293-3.113A4.267 4.267 0 0 0 20.115 0Zm3.448 4.406v15.709c-.047.91-.383 1.724-1.054 2.394-.67.67-1.484 1.006-2.394 1.054h-7.376V15.71h-.958v7.854H4.405c-.91-.047-1.724-.383-2.394-1.054-.67-.67-1.006-1.484-1.054-2.394V4.406c.048-.91.383-1.724 1.054-2.394.671-.67 1.484-1.006 2.394-1.054h7.376v7.854h.958V.958h7.376c.91.047 1.724.383 2.394 1.054.67.67 1.006 1.484 1.054 2.394ZM5.7 11.782l4.31-3.88-.67-.766-4.933 4.454H4.36l-.288.335-.335.287v.096l.335.287.288.335h.047l4.933 4.454.67-.766-4.31-3.88h13.937v-.958H5.699v.002Z' />
);

export const viewBox = '0 0 25 25';
